export default "__VITE_ASSET__Qw5ipGnp__"